exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ExtraInfoCard__background--3RWzi {\n  background-color: #393c42;\n  border-radius: 4px;\n}\n\n.ExtraInfoCard__container--16wvZ {\n  padding: 5px;\n}\n\n.ExtraInfoCard__info--2-3ce {\n  font-weight: 400;\n  padding: 12px;\n  border-bottom: 1px solid #888;\n}\n\n.ExtraInfoCard__info--2-3ce:last-child {\n  border-bottom: 0;\n}\n\n.ExtraInfoCard__label--1YMW- {\n  opacity: 0.54;\n  font-size: 12px;\n  padding-bottom: 5px;\n}\n\n.ExtraInfoCard__value--fXBRA {\n  font-size: 14px;\n}\n\n.ExtraInfoCard__title--3_m4W {\n  padding-top: 5px;\n  padding-left: 12px;\n  font-weight: 900;\n  font-size: 20px;\n}", ""]);

// exports
exports.locals = {
	"background": "ExtraInfoCard__background--3RWzi",
	"container": "ExtraInfoCard__container--16wvZ",
	"info": "ExtraInfoCard__info--2-3ce",
	"label": "ExtraInfoCard__label--1YMW-",
	"value": "ExtraInfoCard__value--fXBRA",
	"title": "ExtraInfoCard__title--3_m4W"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };